import styled, { css } from 'styled-components';

/**
 * Card component for content containers
 * Usage:
 * <Card>Card content</Card>
 * <Card variant="elevated">Elevated Card</Card>
 * <Card variant="outlined">Outlined Card</Card>
 */
const Card = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  transition: transform 0.3s, box-shadow 0.3s;
  
  ${props => {
    switch(props.variant) {
      case 'elevated':
        return css`
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          border: 1px solid rgba(0, 0, 0, 0.05);
          
          &:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
          }
        `;
      case 'outlined':
        return css`
          border: 1px solid rgba(0, 0, 0, 0.12);
          box-shadow: none;
        `;
      case 'interactive':
        return css`
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(0, 0, 0, 0.05);
          cursor: pointer;
          
          &:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          }
        `;
      default:
        return css`
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(0, 0, 0, 0.05);
        `;
    }
  }}
  
  ${props => props.noPadding && css`
    padding: 0;
  `}
  
  ${props => props.noMargin && css`
    margin: 0;
  `}
  
  ${props => props.centered && css`
    text-align: center;
  `}
  
  ${props => props.fullWidth && css`
    width: 100%;
  `}
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  padding: ${props => props.noPadding ? '0' : '1rem 1.5rem'};
  border-bottom: ${props => props.divider ? '1px solid rgba(0, 0, 0, 0.1)' : 'none'};
  
  ${props => !props.noPadding && css`
    margin: -1.5rem -1.5rem 1.5rem -1.5rem;
  `}
`;

export const CardBody = styled.div`
  padding: ${props => props.noPadding ? '0' : '0.5rem 0'};
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align || 'space-between'};
  padding: ${props => props.noPadding ? '0' : '1rem 1.5rem'};
  border-top: ${props => props.divider ? '1px solid rgba(0, 0, 0, 0.1)' : 'none'};
  
  ${props => !props.noPadding && css`
    margin: 1.5rem -1.5rem -1.5rem -1.5rem;
  `}
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
`;

export const CardSubtitle = styled.h4`
  margin: 0.25rem 0 0 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: #5F6368;
`;

export default Card;
